<template>
  <v-row>
    <v-col cols="12">
      <v-autocomplete
        v-model="selectedVia"
        small-chips
        outlined
        chips
        label="Via"
        multiple
        :items="stops"
        item-value="short_name"
        item-text="stop_name"
        :rules="[required]"
      >
        <template v-slot:selection="data">
          <v-chip
            v-bind="data.attrs"
            :input-value="data.selected"
            close
            small
            @click="data.select"
            @click:close="remove(data.item.short_name)"
          >
            {{ data.item.stop_name }}
          </v-chip>
        </template>
      </v-autocomplete>
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { get, sync } from 'vuex-pathify'

export default {
  name: 'ReplacementViaField',

  data: () => ({
    required,
    selectedVia: []
  }),

  computed: {
    stops: get('event/stops'),
    model: sync('replacement/model')
  },

  watch: {
    selectedVia(via) {
      this.$store.set(
        'replacement/model@via',
        via.filter(x => x.length).join(', ')
      )
    }
  },

  created() {
    this.selectedVia = (this.model.via || '').split(', ').map(x => x.trim())
  },

  methods: {
    remove(item) {
      const index = this.selectedVia.indexOf(item)
      if (index >= 0) this.selectedVia.splice(index, 1)
    }
  }
}
</script>
